/**
 * 退回
 */
import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Select, Row, Col, message, Input, Spin, ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import {SFuncModal} from "shj-components";
import {iiHOC} from "@/utils/auth.ts";
import {getEnums} from "@/services/homeService.ts";
import {log} from "console";
import {ticketsBack} from "@/services/customerServices.ts";
const { Option } = Select;
const { TextArea } = Input;

export const WorkerOrderBackTab = (props: any) => <ModalWorkerOrderBackDom {...props} />;

export function modalWorkerOrderBackFn(val: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `退回`,
    vanish: true,
    content: (
      <>
        <ConfigProvider locale={zhCN}>
          <ModalWorkerOrderBackDom onClose={onClose} {...val} />
        </ConfigProvider>
      </>
    ),
  });
  return dialog;
}

const ModalWorkerOrderBackDom = (params: any) => {
  const { onClose, fn, id, issueId, formOnly } = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isSpecial, setIsSpecial] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [ticketsBackTypeEnum, setTicketsBackTypeEnum] = useState<any[]>([]);

  useEffect(() => {
    getOptions()
  }, []);

  const getOptions = async () => {
    const data = await getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.TicketsBackTypeEnum')
    setTicketsBackTypeEnum(data)
  }

  const btnStatus = (otherStatus: boolean) => {
    if (isSpecial) {
      return false;
    }
    return otherStatus;
  };

  const onFinish = () => {
    if (loading) return;
    form.validateFields().then(values => {
      setLoading(true);
      const _parameters = { ...values, id: id.toString() };
      console.log(_parameters)
      // backClassifyId: '',//(integer): 退回分类ID,
      // backDescription: '',//(string): 退回原因,
      // id: id,// 问题ID
      ticketsBack(_parameters).then((resp: any) => {
        message.success(resp.message || '操作成功');
        onClose();
        fn && fn();
      }).finally(() => setLoading(false))
    })

  };
  return iiHOC(
    <div>
      <SFuncModal.Content
        confirmLoading={loading}
        onOk={onFinish}
        cancel={!formOnly}
        okText={'发送'}
        onCancel={onClose}
      >
      <Spin spinning={spinLoading} tip="加载中...">
        <Form
          ref={formNode}
          form={form}
          onFinish={onFinish}
          {...{
            labelCol: {
              xs: { span: 12 },
              sm: { span: 6 },
            },
            wrapperCol: {
              xs: { span: 12 },
              sm: { span: 18 },
            },
          }}
        >
          <Row gutter={2}>
            <Col span={24}>
              <Form.Item label="分类" name="backClassifyId" required rules={[{ required: true, message: '请选择' }]}>
                <Select disabled={btnStatus(false)} placeholder="请选择" allowClear
                  options={ticketsBackTypeEnum}
                        fieldNames={{label: 'description', value: 'key'}}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="原因描述"
                name="backDescription"
                required
                rules={[{ required: true, message: '请输入' }]}
              >
                <TextArea disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} maxLength={200} showCount />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
      </SFuncModal.Content>
    </div>,
  );
};
